import { Link } from "react-router-dom"
import {
  useTheme,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material"
import qs from "qs"

import { LanguageSelector } from "./LanguageSelector"
import { CloseIconButton } from "../Button"
import { useTranslation } from "providers/i18n"
import { useMemo } from "react"
import { getIcon } from "utils/icon"
import { CloseIcon } from "components/icons"

export const Sidebar = ({
  navigations = [],
  onClose = () => {},
  open = false,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const logo = theme.assets?.[`sidebarLogo`] || theme.assets?.[`logo`]

  const { styleOverrides = {} } = theme.components[`AppSidebar`]
  const {
    root,
    header,
    headerTitle,
    closeButton,
    body,
    footer,
    footerLogo,
    navList,
    navListItem,
    navDivider,
    navListWrapper,
    languageSelectorWrapper,
  } = styleOverrides

  const sidebarCloseIcon = useMemo(
    () => getIcon(theme?.assets?.sidebar?.closeIcon) || <CloseIcon />,
    [theme]
  )

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="left"
      PaperProps={{ sx: root }}
    >
      <CloseIconButton
        sx={closeButton}
        icon={sidebarCloseIcon}
        onClick={onClose}
      />

      {/** Header */}
      <Box sx={header}>
        <Box sx={headerTitle}>{t("Menu")}</Box>
      </Box>

      {/** Body */}
      <Box sx={body}>
        {/** Navigation */}
        <List sx={navList} disablePadding>
          {navigations.map((nav, index) => (
            <Box key={nav.to} sx={navListWrapper}>
              <ListItemButton
                id={nav.label}
                data-testid={nav.label}
                component={Link}
                to={`${nav.to}?${qs.stringify(nav.qs)}`}
                sx={navListItem}
              >
                {nav.icon && <ListItemIcon>{nav.icon}</ListItemIcon>}
                {/* //i18n translation fallback */}
                <ListItemText
                  primary={t([`navigation.${nav.label}`, nav.label])}
                />
              </ListItemButton>
              <Divider sx={navDivider} />
            </Box>
          ))}
          <Box sx={languageSelectorWrapper}>
            <LanguageSelector onSwitchedLanguage={onClose} />
          </Box>
        </List>
      </Box>

      {/** Footer */}
      <Box sx={footer}>
        {logo && (
          <Box sx={footerLogo}>
            <img src={logo.url} alt={logo.caption} />
          </Box>
        )}
      </Box>
    </Drawer>
  )
}
